import {useContext} from 'react';
import { useTranslation } from 'react-i18next';
import { SiteType } from './App';

const Verified = () => {
    const { isPcSite } = useContext(SiteType);
    const { t } = useTranslation();
    return (
        <div id={isPcSite ? "formArea" : "formArea-Mobile"}>
            <h1 className="title" id={isPcSite ? "PC" : "Mobile"}>{t('verified.title')}</h1>
            <div id="succeeded">
                <p>{t('verified.message1')}</p>
                <p>{t('verified.message2')}</p>
            </div>
        </div>
    )
}

export default Verified;
